module.exports = __webpack_public_path__ + "static/media/features-split-image-01.b8c78271.png";